import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Modal, ModalBody } from "reactstrap";
import {
	Button,
	Col,
	Form,
	FormFeedback,
	FormGroup,
	Input,
	Label,
	Row,
} from "reactstrap";
import setorService from "../../../../services/SetorService";
import { FloppyDisk, SignOut } from "@phosphor-icons/react";

const ModalSetor = ({ show, onCloseClick }) => {
	const [data, setData] = useState(null);

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			name: data?.name || "",
		},
		validationSchema: Yup.object({
			name: Yup.string().required("Por favor, informe o nome do setor!"),
		}),
		onSubmit: async (values) => {
			if (values) {
				await setorService.post(values);
			}
			onCloseClick();
		},
	});

	useEffect(() => {
		setData(null);
	}, [data]);

	return (
		<Modal size="m" isOpen={show} toggle={onCloseClick} centered={true}>
			<div className="modal-content">
				<ModalBody>
					<div className="page-content">
						<div
							className="container-fluid"
							style={{
								backgroundColor: "white",
								borderRadius: 10,
							}}
						>
							<Form
								className="needs-validation"
								onSubmit={(e) => {
									e.preventDefault();
									validation.handleSubmit();
									return false;
								}}
							>
								<Row>
									<Col md="12">
										<FormGroup className="mb-2">
											<Label htmlFor="validationCustom01">
												Nome do setor
											</Label>
											<Input
												name="name"
												placeholder="Novo Setor"
												type="text"
												className="form-control"
												id="validationCustom01"
												onChange={
													validation.handleChange
												}
												onBlur={validation.handleBlur}
												value={
													validation.values.name || ""
												}
												invalid={
													validation.touched.name &&
													validation.errors.name
														? true
														: false
												}
											/>
											{validation.touched.name &&
											validation.errors.name ? (
												<FormFeedback type="invalid">
													{validation.errors.name}
												</FormFeedback>
											) : null}
										</FormGroup>
									</Col>
								</Row>
								<div
									className="page-title-right"
									style={{
										display: "flex",
										justifyContent: "end",
									}}
								>
									<Button
										type="submit"
										style={{
											background: "none",
											padding: 10,
											cursor: "pointer",
											color: "black",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											gap: 2,
											width: 150,
										}}
									>
										<FloppyDisk size={16} /> Salvar
									</Button>
									<Button
										type="button"
										style={{
											background: "none",
											cursor: "pointer",
											color: "black",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											gap: 2,
											marginLeft: 5,
										}}
										onClick={onCloseClick}
									>
										<SignOut size={16} /> Fechar
									</Button>
								</div>
							</Form>
						</div>
					</div>
				</ModalBody>
			</div>
		</Modal>
	);
};

ModalSetor.propTypes = {
	onCloseClick: PropTypes.func,
	show: PropTypes.bool,
};

export default ModalSetor;
